import { React, useState, useEffect, useRef } from "react";
import OwlCarousel from "react-owl-carousel";
import noImage from "../../assets/images/no-image.jpg";
import ApiService from "../../constants/ApiService";
import Variables from "../../constants/Variables";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import carfinance from "../../assets/images/preown.jpg";
import preabtinfo from "../../assets/images/preabtinfo.png";
import pabt1 from "../../assets/images/pabt1.png";
import pabt2 from "../../assets/images/pabt2.png";
import pabt3 from "../../assets/images/pabt3.png";
import preabtshadow from "../../assets/images/preabt-shadow.png";
import preabut from "../../assets/images/preabut.png";
import roadmap from "../../assets/images/roadmap.png";
import preadd1 from "../../assets/images/preadd1.jpg";
import preadd2 from "../../assets/images/preadd2.jpg";
import loanobt from "../../assets/images/loanobt.png";
import otoemply from "../../assets/images/otoemply.webp";
import preownrfrmbg from "../../assets/images/preownrfrmbg.png";
import config from "../../constants/Env";
import MetaTags from "../../partials/MetaTags";

function PreownedCarFinance({ isShowLoader }) {
  // declare the state
  const [width, setWidth] = useState(window.innerWidth);
  let [partnerData, setPartnerData] = useState({});
  const { postData } = ApiService();
  const navigate = useNavigate();
  let [makeData, setMakeData] = useState([]);
  let [modelData, setModelData] = useState([]);
  let [yearData, setYearData] = useState([]);
  let [variantData, setVariantData] = useState([]);
  let leadform = useRef();
  let [adsData, setAdsData] = useState([]);
  let [cmsData, setCMSData] = useState([]);
  let [documentData, setDocumentData] = useState([]);
  let [bankData, setBankData] = useState([]);
  let [formValue, setFormValue] = useState({
    name: "",
    phone: "",
    brand_id: "",
    model_id: "",
    preferred_bank: "",
    variant: "",
    year: "",
    loan_amount: "",
    page_name: "Pre - Owned Car Finance",
  });
  let [isLoading, setIsLoading] = useState(false);
  let [loanFormValue, setLoanFormValue] = useState({
    loan_amount: 0,
    interest_rate: 0,
    year: 0,
  });
  let [EMIValue, setEMIValue] = useState(0);

  let handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };

  //get cms page data
  let getCMSData = async () => {
    let dataInfo = await postData("cms-page-info", {
      page_slug: "pre-owned-car-finance",
    });
    isShowLoader(false);
    if (dataInfo.responseCode == 200) {
      setCMSData(dataInfo.responseData);

      setTimeout(() => {
        $("#EMICalculator").click(function () {
          $("#emiCalculateModal").show();
        });
      }, 200);
    }
  };

  //get partner list
  let getPartnerList = async () => {
    let dataInfo = await postData("partner-list", {});
    if (dataInfo.responseCode == 200) {
      setPartnerData(dataInfo.responseData);
    }
  };

  let redirectToLeadForm = (e) => {
    e.preventDefault();
    window.scrollTo({ behavior: "smooth", top: leadform.current.offsetTop });
  };

  useEffect(() => {
    getPartnerList();

    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 768;
  let itemPerPage = 8;

  if (isMobile) {
    itemPerPage = 3;
  }

  //change route function
  let changeRoute = (e, path) => {
    e.preventDefault();
    if (path !== null && path !== "") {
      navigate(path);
    }
  };

  //get make list
  let getMake = async () => {
    formValue.model_id = "";
    formValue.year = "";
    setFormValue(formValue);
    setModelData([]);
    setYearData([]);
    setVariantData([]);

    let dataInfo = await postData("brand-list", {});
    if (dataInfo.responseCode == 200) {
      setMakeData(dataInfo.responseData);
    }
  };

  //get model list
  let getModel = async (brand_id) => {
    setModelData([]);
    setVariantData([]);
    let dataInfo = await postData("model-list", { brand_id: brand_id });
    if (dataInfo.responseCode == 200) {
      setModelData(dataInfo.responseData);
    }
  };

  //get year list
  let getYear = async () => {
    setYearData([]);
    let currentYear = new Date().getFullYear();
    for (let i = 2001; i <= currentYear; i++) {
      yearData.push({
        year: i,
      });
    }
    setYearData(yearData);
  };

  //get variant list
  let getVariant = async (model_id) => {
    let dataInfo = await postData("variant-list", {
      brand_id: formValue.brand_id,
      model_id: model_id,
    });
    if (dataInfo.responseCode == 200) {
      setVariantData(dataInfo.responseData);
    }
  };

  //get bank list
  let getBank = async () => {
    let dataInfo = await postData("bank-list");
    if (dataInfo.responseCode == 200) {
      setBankData(dataInfo.responseData);
    }
  };

  //lead form submit func
  let formSubmit = async (e) => {
    e.preventDefault();
    toast.dismiss();

    console.log(formValue, "formValue");

    if (formValue.name == "") {
      toast.error("Name is required");
      return false;
    }
    if (formValue.phone == "") {
      toast.error("Phone number is required");
      return false;
    }
    if (Variables.phoneNumberPattern.test(formValue.phone)) {
      toast.error("Enter valid phone number");
      return false;
    }
    if (formValue.phone.length != 10) {
      toast.error("Phone number should be 10 digits");
      return false;
    }
    if (formValue.brand_id == "") {
      toast.error("Make is required");
      return false;
    }
    if (formValue.model_id == "") {
      toast.error("Model is required");
      return false;
    }
    if (formValue.variant == "") {
      toast.error("Variant is required");
      return false;
    }
    if (formValue.variant == "") {
      toast.error("Variant is required");
      return false;
    }
    if (formValue.preferred_bank == "") {
      toast.error("Bank is required");
      return false;
    }
    if (formValue.year == "") {
      toast.error("Year is required");
      return false;
    }
    if (formValue.loan_amount == "") {
      toast.error("Loan Amount is required");
      return false;
    }

    formValue.brand_id = parseInt(formValue.brand_id);
    formValue.model_id = parseInt(formValue.model_id);
    formValue.preferred_bank = parseInt(formValue.preferred_bank);
    formValue.variant = parseInt(formValue.variant);

    setIsLoading(true);
    let saveData = await postData("finance-lead-submit", formValue);
    setIsLoading(false);

    if (saveData.responseCode == 200) {
      setFormValue({
        ...formValue,
        name: "",
        phone: "",
        brand_id: "",
        model_id: "",
        preferred_bank: "",
        variant: "",
        year: "",
        loan_amount: "",
        fuel_type: "",
      });
      toast.success(Variables.leadSubmitSuccess);
    } else {
      toast.error(Variables.enquirySubmitError);
    }
  };

  //get ads list
  let getAdsData = async () => {
    let dataInfo = await postData("ads-page-info", {
      page_name: "pre-owned-car-finance",
    });
    if (dataInfo.responseCode == 200) {
      setAdsData(dataInfo.responseData);
    }
  };

  //get document list
  let getDocumentData = async () => {
    let dataInfo = await postData("finance-documents-info", {
      page_name: "pre-owned-car-finance",
    });
    if (dataInfo.responseCode == 200) {
      setDocumentData(dataInfo.responseData);
    }
  };

  let closeModal = () => {
    $("#emiCalculateModal").hide();
  };

  useEffect(() => {
    if (cmsData.length > 0) {
      setTimeout(() => {
        $("#EMICalculator").click(function () {});
      }, 200);
    }
  }, [cmsData]);

  let calculateEMI = () => {
    let p = parseFloat(loanFormValue.loan_amount);
    let r = parseFloat(loanFormValue.interest_rate) / 12 / 100;
    let t = parseFloat(loanFormValue.year) * 12;
    let rate = Math.pow(1 + r, t);
    let emiValue = (p * r * rate) / (rate - 1);
    setEMIValue(emiValue);
  };

  useEffect(() => {
    isShowLoader(true);
    getCMSData();
    getMake();
    getBank();
    getAdsData();
    getDocumentData();
    getYear();
  }, []);
  return (
    <div className="mainbodycls">
      <MetaTags pageData={cmsData} />
      <section class="sub-banner">
        <div class="container-fluid">
          <div class="row breadcrumb">
            <img
              src={carfinance}
              class="img-fluid"
              loading="lazy"
              fetchpriority="low"
              alt="banner image"
            />
          </div>
        </div>
        <div class="container">
          <div class="subbannertext">
            <h2>
              Pre - Owned
              <span class="bluee" style={{ marginLeft: "8px" }}>
                Car
              </span>
              <span class="bluee" style={{ marginLeft: "8px" }}>
                Finance
              </span>
            </h2>
            <div class="bredcam">
              <ul>
                <li>
                  <a href="" onClick={(e) => changeRoute(e, "/")}>
                    Home
                  </a>
                </li>
                <li>Pre - Owned Car Finance</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section class="urgntrequire uspdd">
        <div class="citybg">
          <img
            src={preabtinfo}
            loading="lazy"
            fetchpriority="low"
            alt="Pre-Owned car"
          />
        </div>
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div
                dangerouslySetInnerHTML={{
                  __html: cmsData?.page_extra_content
                    ? cmsData?.page_extra_content
                    : "",
                }}
              ></div>
              <a href="" onClick={(e) => redirectToLeadForm(e)}>
                Apply Now
              </a>
            </div>
            <div class="col-lg-6 text-end">
              <div class="precar-abut-info">
                <div class="iconbx">
                  <img
                    src={pabt1}
                    loading="lazy"
                    fetchpriority="low"
                    alt="Icon 1"
                  />
                </div>
                <div class="iconbx">
                  <img
                    src={pabt2}
                    loading="lazy"
                    fetchpriority="low"
                    alt="Icon 2"
                  />
                </div>
                <div class="iconbx">
                  <img
                    src={pabt3}
                    loading="lazy"
                    fetchpriority="low"
                    alt="Icon 3"
                  />
                </div>
              </div>
              <div class="preabut">
                <img
                  class="prbtshp"
                  src={preabtshadow}
                  loading="lazy"
                  fetchpriority="low"
                  alt="Shadow icon"
                />
                <img
                  src={preabut}
                  loading="lazy"
                  fetchpriority="low"
                  alt="Car image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="finance-feture-usp preownrusp-sec">
        <div
          className=""
          dangerouslySetInnerHTML={{
            __html: cmsData?.page_content ? cmsData?.page_content : "",
          }}
        ></div>
        <div
          class="roadpic"
          loading="lazy"
          fetchpriority="low"
          alt="Road image"
        >
          <img
            src={cmsData?.featured_image ? cmsData?.featured_image : roadmap}
          />
        </div>
      </section>
      <section class="required-ducument ductmrgin">
        <div class="container">
          <h2>Required Documents</h2>
          <div class="requiredoc">
            {documentData?.map((item, key) => {
              return (
                <div class="ducumntbx">
                  <div class="docpic">
                    <img
                      src={item?.image}
                      loading="lazy"
                      fetchpriority="low"
                      alt={item?.document_name}
                    />
                  </div>
                  <p>{item?.document_name}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <section class="two-add-show mrgtp0">
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              {adsData.length > 0 ? (
                <div class="uspadd-box">
                  <img
                    src={
                      adsData[0]?.image_name
                        ? config.assetsBaseUrl + adsData[0]?.image_name
                        : preadd1
                    }
                    loading="lazy"
                    fetchpriority="low"
                    alt="buy your car"
                  />
                  <div class="adredbg">
                    <div class="lookdtl">
                      <span>
                        <img
                          src={loanobt}
                          loading="lazy"
                          fetchpriority="low"
                          alt="OtoBix"
                        />
                      </span>
                      <h3>{adsData[0]?.content_1} </h3>
                      <p>{adsData[0]?.content_2}</p>
                      <a
                        href=""
                        className="lokibtn"
                        onClick={(e) => changeRoute(e, adsData[0].redirect_url)}
                      >
                        Click Here
                      </a>
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
            <div class="col-lg-6">
              {adsData.length > 1 ? (
                <div class="uspadd-box">
                  <img
                    src={
                      adsData[1]?.image_name
                        ? config.assetsBaseUrl + adsData[1]?.image_name
                        : preadd2
                    }
                    loading="lazy"
                    fetchpriority="low"
                    alt="sell your car"
                  />
                  <div class="uspfrst-add2">
                    <img
                      src={loanobt}
                      loading="lazy"
                      fetchpriority="low"
                      alt="OtoBix"
                    />
                    <h5>
                      {adsData[1]?.content_1}
                      <br /> {adsData[1]?.content_2}
                    </h5>
                    <p>{adsData[1]?.content_3}</p>
                    <a
                      href=""
                      className="lokibtn2"
                      onClick={(e) => changeRoute(e, adsData[1].redirect_url)}
                    >
                      Click Here
                    </a>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </section>
      <section class="BrandLogo prtnrbnd">
        <div class="container">
          <div class="heading cntrtxt">
            <h2>Our Lending Partners</h2>
          </div>
          <div class="row">
            {partnerData?.leadingPartnerData?.length > 0 ? (
              <OwlCarousel
                class="owl-carousel owl-theme brand"
                loop
                margin={0}
                nav
                items={itemPerPage}
                autoplay={true}
                autoplaySpeed={100}
              >
                {partnerData?.leadingPartnerData?.map((item, i) => {
                  return (
                    <div class="item" key={i}>
                      <img
                        src={item?.image ? item?.image : noImage}
                        loading="lazy"
                        fetchpriority="low"
                        alt="Partner image"
                      />
                    </div>
                  );
                })}
              </OwlCarousel>
            ) : (
              <></>
            )}
          </div>
        </div>
      </section>
      <section
        class="fetureusp-info preownrbgnon"
        style={{ backgroundImage: `url(${preownrfrmbg})` }}
        ref={leadform}
      >
        <div class="otobxemply">
          <img
            src={otoemply}
            loading="lazy"
            fetchpriority="low"
            alt="Car finance image"
          />
        </div>
        <div class="container">
          <div class="loan-from financfrom">
            <div class="row">
              <div class="col-lg-12">
                <h2>Pre - Owned Car Finance</h2>
              </div>
              <div class="col-lg-6 col-md-6">
                <div class="bkfrom">
                  <input
                    type="text"
                    class="form-control"
                    id="name"
                    name="Name"
                    placeholder="Name*"
                    onChange={(e) =>
                      setFormValue({ ...formValue, name: e.target.value })
                    }
                    value={formValue.name}
                  />
                </div>
              </div>
              <div class="col-lg-6 col-md-6">
                <div class="bkfrom">
                  <input
                    type="text"
                    class="form-control"
                    id="phone"
                    placeholder="Contact Number*"
                    name="phone"
                    onChange={(e) =>
                      setFormValue({ ...formValue, phone: e.target.value })
                    }
                    value={formValue.phone}
                  />
                </div>
              </div>
              <div class="col-lg-6 col-md-6">
                <div class="bkfrom">
                  <select
                    name="make"
                    defaultValue={formValue.brand_id}
                    value={formValue.brand_id}
                    onChange={(e) => {
                      setFormValue({
                        ...formValue,
                        brand_id: e.target.value,
                      });
                      getModel(e.target.value);
                    }}
                  >
                    <option value="">Make*</option>
                    {makeData?.map((item, i) => {
                      return (
                        <option key={i} value={item?.id}>
                          {item?.brand_name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div class="col-lg-6 col-md-6">
                <div class="bkfrom">
                  <select
                    name="model_id"
                    defaultValue={formValue.model_id}
                    value={formValue.model_id}
                    onChange={(e) => {
                      setFormValue({
                        ...formValue,
                        model_id: e.target.value,
                      });
                      getVariant(e.target.value);
                    }}
                  >
                    <option value="">Model*</option>
                    {modelData?.map((item, i) => {
                      return (
                        <option key={i} value={item?.id}>
                          {item?.model_name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div class="col-lg-6 col-md-6">
                <div class="bkfrom">
                  <select
                    name="variant"
                    defaultValue={formValue.variant}
                    value={formValue.variant}
                    onChange={(e) => {
                      setFormValue({ ...formValue, variant: e.target.value });
                    }}
                  >
                    <option value="">Variant*</option>
                    {variantData?.map((item, i) => {
                      return (
                        <option key={i} value={item?.id}>
                          {item?.variant_name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div class="col-lg-6 col-md-6">
                <div class="bkfrom">
                  <select
                    name="preferred_bank"
                    defaultValue={formValue.preferred_bank}
                    value={formValue.preferred_bank}
                    onChange={(e) => {
                      setFormValue({
                        ...formValue,
                        preferred_bank: e.target.value,
                      });
                    }}
                  >
                    <option>Preferred Bank*</option>
                    {bankData?.map((item, i) => {
                      return (
                        <option key={i} value={item?.id}>
                          {item?.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div class="col-lg-6 col-md-6">
                <div class="bkfrom">
                  <select
                    name="year"
                    defaultValue={formValue.year}
                    value={formValue.year}
                    onChange={(e) => {
                      setFormValue({ ...formValue, year: e.target.value });
                    }}
                  >
                    <option value="">Year of Registration*</option>
                    {yearData?.map((item, i) => {
                      return (
                        <option key={i} value={item?.year}>
                          {item?.year}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div class="col-lg-6 col-md-6">
                <div class="bkfrom">
                  <input
                    type="text"
                    class="form-control"
                    id="exampleFormControlInput1"
                    placeholder="Loan Amount*"
                    name="loan_amount"
                    min={0}
                    onChange={(e) =>
                      setFormValue({
                        ...formValue,
                        loan_amount: e.target.value.replace(/[^0-9]/g, ""),
                      })
                    }
                    value={formValue.loan_amount}
                  />
                </div>
              </div>
              <div class="col-lg-12">
                <div class="bkfrom text-center prefncbtn">
                  <button onClick={(e) => formSubmit(e)}>
                    {isLoading ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* EMI Calculator  */}
      <div
        class="modal emiCalculateModal"
        id="emiCalculateModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content" style={{ marginTop: 100 }}>
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                EMI Calculator
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => closeModal()}
              ></button>
            </div>
            <div class="modal-body">
              <form>
                <div class="mb-3">
                  <label for="" class="form-label">
                    Loan Amount
                  </label>
                  <input
                    type="number"
                    min={0}
                    class="form-control"
                    id="loan_amount"
                    name="loan_amount"
                    onChange={(e) => {
                      setLoanFormValue({
                        ...loanFormValue,
                        loan_amount: e.target.value,
                      });
                    }}
                  />
                </div>
                <div class="mb-3">
                  <label for="" class="form-label">
                    Interest Rate
                  </label>
                  <input
                    type="number"
                    min={0}
                    class="form-control"
                    id="interest_rate"
                    name="interest_rate"
                    onChange={(e) => {
                      setLoanFormValue({
                        ...loanFormValue,
                        interest_rate: e.target.value,
                      });
                    }}
                  />
                </div>
                <div class="mb-3">
                  <label for="" class="form-label">
                    Years
                  </label>
                  <input
                    type="number"
                    min={0}
                    class="form-control"
                    name="year"
                    id="year"
                    onChange={(e) => {
                      setLoanFormValue({
                        ...loanFormValue,
                        year: e.target.value,
                      });
                    }}
                  />
                </div>
                <button
                  type="button"
                  class="btn btn-primary calculatebtn"
                  onClick={() => calculateEMI()}
                >
                  Calculate
                </button>
                {EMIValue >= 0 ? (
                  <div className="mt-3">EMI: {parseInt(EMIValue)} / Month</div>
                ) : (
                  <></>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PreownedCarFinance;
